import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
  createTransaction,
  getAllTransactions,
  getTransactionById,
  updateTransaction,
  deleteTransaction
} from '../../api'
import { fetchSocieties } from './societySlice'

export const fetchTransactions = createAsyncThunk(
  'transactions/fetchAll',
  async ({
    societyId,
    transactionDirection, // <-- fix key name
    transactionType, // <-- add this
    page,
    limit,
    description,
    startDate,
    endDate,
    sortOrder
  }) => {
    const data = await getAllTransactions(
      page,
      limit,
      transactionDirection, // <-- fix key name
      societyId,
      description,
      startDate,
      endDate,
      sortOrder,
      transactionType // <-- add this
    )
    return { societyId, data }
  }
)

export const fetchTransactionById = createAsyncThunk(
  'transactions/fetchById',
  async id => {
    const data = await getTransactionById(id)
    return data
  }
)

export const addTransaction = createAsyncThunk(
  'transactions/add',
  async transactionData => {
    const data = await createTransaction(transactionData)
    return data
  }
)

export const modifyTransaction = createAsyncThunk(
  'transactions/modifyTransaction',
  async ({ id, transactionData }, { dispatch }) => {
    try {
      const response = await updateTransaction(id, transactionData)
      return response
    } catch (error) {
      throw error
    }
  }
)

export const removeTransaction = createAsyncThunk(
  'transactions/removeTransaction',
  async (transactionId, { dispatch }) => {
    try {
      const response = await deleteTransaction(transactionId)
      return response
    } catch (error) {
      throw error
    }
  }
)

// Slice
const transactionSlice = createSlice({
  name: 'transactions',
  initialState: {
    transactions: {}, // Keyed by societyId
    currentTransaction: null,
    loading: false,
    error: null
  },
  reducers: {
    updateSocietyTransaction: (state, action) => {
      const { societyId, transactionData } = action.payload
      // Update the transaction in the society's FinancialTransaction array
      if (state.transactions[societyId]) {
        const index = state.transactions[societyId].findIndex(
          t => t._id === transactionData._id
        )
        if (index !== -1) {
          state.transactions[societyId][index] = transactionData
        }
      }
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchTransactions.pending, state => {
        state.loading = true
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading = false
        state.transactions = action.payload
      })

      .addCase(fetchTransactions.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
      .addCase(fetchTransactionById.fulfilled, (state, action) => {
        state.currentTransaction = action.payload
      })
      .addCase(addTransaction.fulfilled, (state, action) => {
        const created = action.payload?.transaction || action.payload
        const societyId = action.payload?.societyId || created?.society_id || action.meta?.arg?.societyId
        if (!societyId) return
        if (!state.transactions[societyId]) {
          state.transactions[societyId] = []
        }
        state.transactions[societyId].push(created)
      })
      .addCase(modifyTransaction.fulfilled, (state, action) => {
        const updated = action.payload?.updatedTransaction || action.payload
        const societyId = action.payload?.societyId || updated?.society_id || action.meta?.arg?.societyId
        if (!societyId || !updated?._id) return
        if (state.transactions[societyId]) {
          const index = state.transactions[societyId].findIndex(
            t => t._id === updated._id
          )
          if (index !== -1) {
            state.transactions[societyId][index] = updated
          }
        }
      })
      .addCase(removeTransaction.fulfilled, (state, action) => {
        const id = action.payload?.id || action.meta?.arg
        const societyId = action.payload?.societyId || action.meta?.arg?.societyId
        if (!id || !societyId) return
        if (state.transactions[societyId]) {
          state.transactions[societyId] = state.transactions[societyId].filter(
            t => t._id !== id
          )
        }
      })
  }
})

export default transactionSlice.reducer
